<template>
  <Modal v-model="isShow"
         :width="800"
         :mask-closable="false"
         :loading="loading"
         @on-ok="save"
         @on-cancel="cancel"
  >
    <h3>入库</h3>
<!--    <div class="modalnobefore">-->
<!--      <div class="flex-box">-->
        <Form ref="form" :rules="formRules" :model="formData" style="margin-top:24px" :label-width="100" >
<!--          <Row>-->
<!--            <Col span="6">-->
<!--              <FormItem label="资产编码" prop="assetsCode">-->
<!--                <Input id="suggestIdbase4" style="width:200px" v-model="formData.assetsCode" @on-blur="findAssets" />-->
<!--              </FormItem>-->
<!--            </Col>-->
<!--          </Row>-->
          <Row>
              <FormItem label="资产编码" prop="assetsCode">
                <Select
                    v-model="formData.assetsCode"
                    filterable
                    remote
                    :remote-method="remoteMethod"
                    :loading="loading"
                    placeholder="请输入想查询的资产编号"
                    style="width:200px" @on-change="findAssets">
                  <Option v-for="item in assetsCodeList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
          </Row>
          <Row>
            <Col span="6">
              <FormItem label="资产名称" prop="assetsName">
                <input id="suggestIdbase1" style="width:200px" v-model="formData.assetsName" class="input-long ivu-input" />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="6">
              <FormItem label="资产一级分类" prop="oneCategoryName">
                <Select v-model="formData.oneCategoryName" placeholder="请选择" style="width: 200px" @on-change="getTwo">
                  <Option value=''>请选择</Option>
                  <Option v-for="(item,index) in oneCategoryListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="6">
              <FormItem label="资产二级分类" prop="twoCategoryName">
                <Select v-model="formData.twoCategoryName" placeholder="请选择" style="width: 200px">
                  <Option value=''>请选择</Option>
                  <Option v-for="(item,index) in twoCategoryListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
<!--          <Row>-->
<!--            <Col span="6">-->
<!--              <FormItem label="资产状态" prop="assetsStatus" :label-width="100">-->
<!--                <Select v-model="formData.assetsStatus" style="width:200px">-->
<!--                  <Option value=''>请选择</Option>-->
<!--                  <Option v-for="(item,index) in assetsStatusListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>-->
<!--                </Select>-->
<!--              </FormItem>-->
<!--            </Col>-->
<!--          </Row>-->
          <Row>
            <Col span="6">
              <FormItem label="资产总数" prop="putNumber">
                <input id="suggestIdbase3" style="width:200px" v-model="formData.putNumber" class="input-long ivu-input" />
              </FormItem>
            </Col>
          </Row>
<!--          <Row>-->
<!--            <Col span="6">-->
<!--              <FormItem label="入库时间" prop="stockStorageTime">-->
<!--                <Date-picker style="width:200px" type="date" v-model="formData.stockStorageTime" placeholder="选择日期" format="yyyy-MM-dd" ></Date-picker>-->
<!--              </FormItem>-->
<!--            </Col>-->
<!--          </Row>-->
        </Form>
        <Form
            :ref="'search'+index"
            :model="itemP"
            :label-width="100"
            v-for="(itemP,index) in sizeDtos"
            :key="'index2'+index"
        >
          <Row class="max64">
            <Col span="6">
              <FormItem prop="sizeCode" label="规格型号">
                <input style="width:120px" v-model="itemP.sizeCode" class="input-long ivu-input" />
              </FormItem>
            </Col>
<!--            <Col span="5">-->
<!--              <FormItem prop="sizeNum" label="数量">-->
<!--                <input style="width:80px" v-model="itemP.sizeNum" class="input-long ivu-input" />-->
<!--              </FormItem>-->
<!--            </Col>-->
            <Col span="6">
              <FormItem prop="unit" label="单位">
                <Select v-model="itemP.unit" style="width:80px">
                  <Option value=''>请选择</Option>
                  <Option v-for="(item,index) in unitListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="4"  v-if="!index">
              <a style="line-height:32px;margin-left:10px" @click.stop="addItem"> + 添加</a>
            </Col>
            <Col span="4" v-if="index">
              <a style="line-height:32px;margin-left:10px" @click.stop="deleteItem(itemP,index)"> 删除</a>
            </Col>
<!--            <Col span="4">-->
<!--              <a style="line-height:32px;margin-left:10px" @click.stop="provide(itemP.fid,index)"> 发放</a>-->
<!--            </Col>-->
          </Row>
        </Form>
<!--      </div>-->
<!--    </div>-->
  </Modal>
</template>

<script>
import {getAssetsByAccetsCode, saveAssetsPutRecordInfo,getLikeCodeByAccetsCode} from "api/assets";
import {getCategoryTypeList} from "api/assets";
import {formatDateTime} from "utils/format";
import {fuzzyRoom} from "api/functionalArea";

export default {
  watch:{
    n(val){
      this.loading=true,
      this.isShow = true,
      this.$refs['form'].resetFields();
      if(this.$refs['search0']){
        this.$refs['search0'][0].resetFields()
      }
      this.sizeDtos =[
        {
          fid:'',
          sizeCode:'',
          // sizeNum:'',
          unit:'',
        }
      ]
    },
  },
  props: {
    pid:{
      default:null
    },
    n:{
      default:0
    }
  },
  data() {
    return {
      loading:true,
      isShow:false,
      sizeDtos :[],
      assetsCodeList:[],
      assetsStatusListData: [
        {
          value: 0,
          text: '已入库',
        },
        {
          value: 1,
          text: '已发放',
        },
        {
          value: 2,
          text: '部分发放',
        }
      ],
      unitListData:[],
      oneCategoryListData: [],
      twoCategoryListData:[],
      map: null,
      type: 'polygon',
      formData: {
        oneCategoryName:'',
        twoCategoryName:'',
        assetsName:'',
        assetsCode:'',
        putNumber:'',
      },
      formRules:{
        assetsName:[{ required: true, message: '*' ,trigger: 'change', type:'string'}],
        assetsCode:[{ required: true, message: '*' ,trigger: 'change', type:'string'}],
        // stockStorageTime:[{ required: true, message: '*' ,trigger: 'change', type:'date', validator: this.validateDate}],
        // oneCategoryName:[{ required: true, message: '*' ,trigger: 'change', type:'string'}],
        // twoCategoryName:[{ required: true, message: '*' ,trigger: 'change', type:'string'}],
        // assetsStatus:[{ required: true, message: '*' ,trigger: 'change', type:'number'}],
        putNumber:[{ required: true, message: '请输入数字' ,trigger: 'change', validator: this.validateNumber}]
      },
      // ruleValidate2:{
      //   sizeCode:[
      //     { required: true, message: '*', trigger: 'change',type:'string'}
      //   ],
      //   sizeNum:[
      //     { required: true, message: '*', trigger: 'change',type:'number'}
      //   ],
      // }
    };
  },
  created(){
    getCategoryTypeList(
        {
          parentCategoryCode:-1
        }
    ).then(res => {
      if (!res.data) {
        return
      }
      this.oneCategoryListData = res.data.categoryList
      this.unitListData = res.data.unitCondition
    }).catch(() => {
      return
    })

  },
  mounted() {

  },
  methods: {
  addItem(){
    this.sizeDtos.push(
        {
          fid:'',
          sizeCode:'',
          // sizeNum:'',
          unit:'',
        }
    )
  },
    deleteItem(item,index){
      this.$Modal.confirm({
        content: '<p>确认删除？</p>',
        onOk:() => {
          this.sizeDtos.splice(index,1)
        }
      })
    },
    provide(item,index){

    },
  validateNumber(rule, value, callback) {
    const pattern = /^\d+$/
    if (!pattern.test(value)) {
      callback(new Error('请输入正确数字'));
    }
    callback();
  },
    ok() {
      getList();
    },
    getTwo(value){
      if (!value){
        return
      }
      getCategoryTypeList(
          {
            parentCategoryCode:value
          }
      ).then(res => {
        if (!res.data) {
          return
        }
        this.twoCategoryListData = res.data.categoryList
      }).catch(() => {
        return
      })
    },
    clear() {

    },
    close() {
    },
    // getDetail(){
    //   getAssetsInfoByFid({assetsFid:this.pid}).then( res=> {
    //     this.formData.oneCategoryName = res.data.oneCategoryName
    //     this.formData.twoCategoryName = res.data.twoCategoryName
    //     this.formData.assetsName = res.data.assetsName
    //     this.formData.assetsCode = res.data.assetsCode
    //     this.formData.assetsStatus = res.data.assetsStatus
    //     this.formData.stockNumber = res.data.stockNumber
    //     this.formData.stockStorageTime = this.format(res.data.stockStorageTime)
    //     this.sizeDtos = res.data.sizeDtos
    //   })
    // },
    format(data, showTime = true) {
      if (!data) {
        return ''
      }
      return formatDateTime(data, showTime)
    },
    cancel(){
      this.loading = false;
      this.isShow = false;
    },
    save() {
      this.$refs['form'].validate( bool => {
        if(bool){
          // if(this.pid&&this.pid!=''){
          //   const param = {
          //     fid:this.pid,
          //     sizeDtos:this.sizeDtos,
          //     ...this.formData
          //   }
          //   updateAssetsInfo(param).then( res=> {
          //     this.$Message.success('更新成功');
          //     this.changeLoading()
          //     this.$emit('done')
          //     this.isShow=false
          //   }).catch( () => {
          //     this.changeLoading()
          //     return
          //   })
          // }else {
          const param = {
            sizeDtos:this.sizeDtos,
            ...this.formData
          }
          saveAssetsPutRecordInfo(param).then( res=> {
            this.$Message.success('保存成功');
            this.changeLoading()
            this.$emit('done')
            this.isShow=false
          }).catch( () => {
            this.changeLoading()
            return
          })
          // }
        }else{
          this.changeLoading()
          return
        }
      })

    },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },

    findAssets(){
      // console.log(this.formData.assetsCode)
      getAssetsByAccetsCode(
          {
            assetsCode:this.formData.assetsCode
          }
      ).then(res => {
        if (!res.data) {
          return
        }
        this.formData.assetsName = res.data.assetsName
      }).catch(() => {
        return
      })
    },

    remoteMethod(query){
      if (query !== '') {
        this.loading = true;
        let params = {
          assetsCode:query
        }
        // console.log(query)
        getLikeCodeByAccetsCode(params).then(res => {
          this.loading = false;
          // if(res.data.length==0){
          //   this.assetsCodeList = [{vlaue:this.formData.assetsCode,text:this.formData.assetsCode}];
          // }else {
            this.assetsCodeList = res.data;
          // }
        }).catch(() => {
          return
        })
      } else {
        this.assetsCodeList = [];
        this.formData.assetsCode = ''
      }
    },
  },
};
</script>

<style lang="less" scoped>
.modalnobefore {
  padding: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 500px;
}
.flex-box {
  //display: flex;
  //margin-bottom: 24px;
  //& > div {
  //  flex: auto;
  //  display: flex;
  //  margin-right: 20px;
  //  span {
  //    display: flex;
  //    width: auto;
  //    line-height: 30px;
  //  }
  //
  //}
}
.content-box {
  flex: 1;
  display: flex;
  position: relative;
  .content-l {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
  }
  #grouplist {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .content-r {
    flex: auto;
    .r-title {
      background: #649dd6;
      color: #fff;
      padding-left: 20px;
      height: 30px;
      line-height: 30px;
      .refresh {
        color: #fff;
        cursor: pointer;
        float: right;
        margin-right: 20px;
      }
    }
    .content {
      padding: 20px;
      li {
        border-bottom: 1px solid #ccc;
        margin-bottom: 10px;
        &:last-child {
          border-bottom: none;
        }
        p {
          height: 30px;
          line-height: 30px;
          .r-name {
            font-weight: bold;
            color: green;
            cursor: pointer;
            display: inline-block;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
.model-new{
  height:600px;
}
#container {
  /deep/ .amap-info-content {
    padding: 0;
    background: #fff;
    min-width: 250px;
  }
  /deep/ .amap-info-close {
    right: 0 !important;
    top: 3px;
  }
  /deep/ .info-content {
    padding: 10px;
    p {
      line-height: 25px;
      height: 25px;
      padding: 5px;
      color: #333;
      word-break: break-all;
      width: 200px;
    }
    margin-bottom: 10px;
  }
}
</style>
